export default "__VITE_ASSET___u7Vjur1__"